function space(t) {
  return [[-50, 0], 1.01];
}

module.exports = [[space]];



/*****************
 ** WEBPACK FOOTER
 ** ../JSCalligrapher/alphabets/abjad/space.js
 ** module id = 20
 ** module chunks = 0
 **/